import { autoinject, bindable, computedFrom } from "aurelia-framework";
import { type BannerGrouping } from "../../../models/vessels/vessel.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { RightShipDialogServiceConstants } from "../../../constants/basics/rightship-dialog.constants";
import { Reflection } from "../../../utilities/reflection";
import { StringUtilities } from "../../../utilities/strings";

@autoinject
export class CompBannerSanctioned {

    @bindable
    banner: BannerGrouping;

    @bindable
    isVesselBanner: boolean;

    constructor(private dialogClientService: DialogClientService) { }

    onBannerClick(bannerGroup: BannerGrouping) {
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.BannerDescription, 
            { bannerGroup : bannerGroup, isVesselBanner : this.isVesselBanner }, true, false, false, "right");
    }

    @computedFrom(Reflection.getPropertyPath<CompBannerSanctioned>(x => x.banner),
        Reflection.getPropertyPath<CompBannerSanctioned>(x => x.isVesselBanner))
    get bannerInfoText(): string {

        //Get the type of banner
        const type = this.banner.bannerDueToCompany && this.banner.bannerDueToVessel ? "Vessel and Company" : 
            this.banner.bannerDueToCompany || !this.isVesselBanner ? "Company" : 
                this.banner.bannerDueToVessel || this.isVesselBanner? "Vessel": "";

        const text = `sanctioned ${this.isVesselBanner? 'vessel' : 'company'}`
        for (let i = 0; i < this.banner.response.length; i++) {

            //If there is one of the banners because the entity is sanctioned, then the display name takes priority over associated sanctions
            this.banner.displayName = this.banner.displayName == text? text : this.banner.response[i].displayName;
        }
        const bannerName = StringUtilities.titelize(this.banner.displayName ?? '');
        return type == "" ? null : type + " " + bannerName;
    }
}